import type { ReactNode } from "react";
import { ConsentBanner } from "./ConsentBanner";
import { openConsentPreferences } from "../../lib/consent";

export function PolicyLayout({
  title,
  effectiveDate,
  children,
}: {
  title: string;
  effectiveDate: string;
  children: ReactNode;
}) {
  return (
    <div className="bg-background text-foreground min-h-screen font-body">
      <header className="border-b border-border">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3 text-left">
            <img src="/logo.png" alt="" className="w-[52px] h-[52px] shrink-0" />
            <span>
              <span className="font-display text-lg font-semibold text-primary leading-tight block">
                Pediatric Speech Solutions
              </span>
              <span className="text-xs text-muted-foreground">Stuart &amp; Treasure Coast, FL</span>
            </span>
          </a>
          <a
            href="/"
            className="text-sm font-medium text-foreground/65 hover:text-primary transition-colors"
          >
            <span aria-hidden="true">←</span> Back to Home
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16 md:py-20">
        <span className="text-accent text-xs font-semibold tracking-[0.2em] uppercase mb-4 block">
          Legal
        </span>
        <h1 className="font-display text-3xl md:text-4xl font-semibold text-foreground mb-3">
          {title}
        </h1>
        <p className="text-sm text-muted-foreground mb-12">Effective Date: {effectiveDate}</p>

        <div className="space-y-10 [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-foreground [&_h2]:mb-3 [&_p]:text-muted-foreground [&_p]:leading-relaxed [&_p]:mb-3 [&_li]:text-muted-foreground [&_li]:leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5">
          {children}
        </div>
      </main>

      <footer className="bg-foreground text-background px-6 py-8">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background/55">
            © 2026 Pediatric Speech Solutions. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="/privacy/" className="text-xs text-background/50 hover:text-background/80 transition-colors">
              Privacy Policy
            </a>
            <span className="text-background/25" aria-hidden="true">·</span>
            <a href="/terms/" className="text-xs text-background/50 hover:text-background/80 transition-colors">
              Terms of Use
            </a>
            <span className="text-background/25" aria-hidden="true">·</span>
            <button
              type="button"
              onClick={openConsentPreferences}
              className="text-xs text-background/50 hover:text-background/80 transition-colors"
            >
              Cookie Preferences
            </button>
          </div>
        </div>
      </footer>

      <ConsentBanner />
    </div>
  );
}
